import React, {Fragment} from 'react';
import {Route, Switch} from 'react-router-dom';

import Document from './Form/Documents';
import Checklist from './Form/CheckLists';
import Quizz from './Form/Quizzes';
import SalesCoachSection from './SalesCoachSection';


export default function Index(props){

  return(
    <Switch>
      <Route path='/sales_coach/documents/new' render={(route)=><Document {...props} {...route}/>}/>
      <Route path='/sales_coach/documents/:id/edit' render={(route)=><Document {...props} {...route}/>}/>
      <Route path='/sales_coach/checklists/new' render={(route)=><Checklist {...props} {...route}/>}/>
      <Route path='/sales_coach/checklists/:id/edit' render={(route)=><Checklist {...props} {...route}/>}/>
      <Route path='/sales_coach/quizzes/new' render={(route)=><Quizz {...props} {...route}/>}/>
      <Route path='/sales_coach/quizzes/:id/edit' render={(route)=><Quizz {...props} {...route}/>}/>

      <Route path='/sales_coach' render={(route)=><SalesCoachSection {...props} {...route}/>}/>
    </Switch>
  )
}
